const ArrowCircle = () => {
    return (
        <svg
            width="157"
            height="343"
            viewBox="0 0 157 343"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M134 240C85.3995 240 46 200.601 46 152C46 103.399 85.3995 64 134 64"
                stroke="url(#paint0_linear_1167_22236)"
                strokeWidth="2.10383"
                strokeMiterlimit="10"
            />
            <path
                d="M118 48L134 63.976L118 80"
                stroke="white"
                strokeWidth="2.10383"
                strokeMiterlimit="10"
            />
            <circle
                cx="148.5"
                cy="148.5"
                r="147.25"
                stroke="#4C9AFF"
                strokeWidth="2.5"
            />
            <g filter="url(#filter0_d_1167_22236)">
                <path
                    d="M160.785 218H136.262L124 239L136.262 260H160.785L173 239L160.785 218Z"
                    fill="url(#paint1_linear_1167_22236)"
                    shapeRendering="crispEdges"
                />
                <path
                    d="M125.158 239L136.836 219H160.21L171.843 239L160.21 259H136.836L125.158 239Z"
                    stroke="#B3D4FF"
                    strokeWidth="2"
                    shapeRendering="crispEdges"
                />
            </g>
            <rect
                x="112.25"
                y="341.75"
                width="148.5"
                height="72.5"
                rx="36.25"
                transform="rotate(-90 112.25 341.75)"
                stroke="#4C9AFF"
                strokeWidth="2.5"
            />
            <path
                d="M148.5 319C161.479 319 172 308.479 172 295.5C172 282.521 161.479 272 148.5 272C135.521 272 125 282.521 125 295.5C125 308.479 135.521 319 148.5 319Z"
                fill="url(#paint2_linear_1167_22236)"
            />
            <defs>
                <filter
                    id="filter0_d_1167_22236"
                    x="92"
                    y="186"
                    width="113"
                    height="106"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="16" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.0156863 0 0 0 0 0.364706 0 0 0 0 0.894118 0 0 0 1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1167_22236"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1167_22236"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_1167_22236"
                    x1="90"
                    y1="64"
                    x2="90"
                    y2="240"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.15" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1167_22236"
                    x1="131.776"
                    y1="255.539"
                    x2="164.898"
                    y2="222.066"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#0065FF" />
                    <stop offset="1" stopColor="#0065FF" stopOpacity="0.67" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_1167_22236"
                    x1="131.894"
                    y1="312.131"
                    x2="165.128"
                    y2="278.897"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F8A703" />
                    <stop offset="1" stopColor="#FAA802" stopOpacity="0.67" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default ArrowCircle;
